@if (!isAuthRoute()) {
<header class="rt-header" #header>
  <div class="rt-container">
    <div class="rt-logo">
      <figure>
        <a title="Riterz" [routerLink]="['/']">
          <img src="assets/riterz-logo.svg" alt="Riterz"/>
        </a>
      </figure>
    </div>

    <div
      class="rt-header-menu-toggle rt-clickable"
      (click)="opMenu.toggle($event)"
      (keydown.space)="opMenu.toggle($event)"
      tabindex="0"
    >
      <i class="pi pi-bars" style="font-size: 1.5rem;"></i>
    </div>
    <p-popover #opMenu appendTo="body">
      <nav class="rt-nav" style="width: 300px;">
        @if (currentUser()?.status !== 'pending' && currentUser()?.status !== 'rejected') {
          <p-button
            label="Submit your Profile"
            [text]="true"
            [rounded]="true"
            severity="secondary"
            (click)="openProfileForm()"
          />
          <p-divider></p-divider>
        }
        <ul>
          @if (currentUser()?.status !== 'pending' && currentUser()?.status !== 'rejected') {
            <li>
              <a [routerLink]="['/discover']" title="Discover" (click)="opMenu.hide()">Discover</a>
            </li>
            <li>
              <p-divider></p-divider>
            </li>
          }
          <li>
            <a href="https://www.riterz.com/for-brands" title="For Brands">For Brands</a>
          </li>
          <li>
            <a href="https://www.riterz.com/for-rights-holders" title="For Rights Holders">For Rights Holders</a>
          </li>
          <li>
            <a href="https://www.riterz.com/for-agencies" title="For Agencies">For Agencies</a>
          </li>
          <li>
            <a href="https://www.riterz.com/how-it-works">How it works</a>
          </li>
          <li>
            <a href="https://www.riterz.com/knowledge-center">Knowledge center</a>
          </li>
          <li>
            <a href="https://www.riterz.com/pricing">Pricing</a>
          </li>
          <li>
            <p-divider></p-divider>
          </li>
          <li>
            <a href="https://www.riterz.com/about-us">About us</a>
          </li>
          <li>
            <a href="https://www.riterz.com/partners">Partners</a>
          </li>
          <li>
            <a href="https://riterz.bamboohr.com/careers">Careers</a>
          </li>
          <li>
            <a href="https://www.riterz.com/contact-us">Contact us</a>
          </li>
        </ul>
      </nav>
    </p-popover>

    <nav class="rt-header-menu">
      <ul>
        <li>
          <a href="https://www.riterz.com/for-brands" title="For Brands">For Brands</a>
        </li>
        <li>
          <a href="https://www.riterz.com/for-rights-holders" title="For Rights Holders">For Rights Holders</a>
        </li>
        <li>
          <a href="https://www.riterz.com/for-agencies" title="For Agencies">For Agencies</a>
        </li>
        <li>
          <a
            tabindex="0"
            class="rt-clickable"
            title="Explore"
            (click)="opExplore.toggle($event)"
            (keydown.space)="opExplore.toggle($event)"
          >Explore</a>
          <p-popover
            #opExplore
            appendTo="body"
            [style]="{ marginTop: '20px' }"
          >
            <nav class="rt-nav" style="width: 300px;">
              <ul>
                <li>
                  <a href="https://www.riterz.com/how-it-works">How it works</a>
                </li>
                <li>
                  <a href="https://www.riterz.com/knowledge-center">Knowledge center</a>
                </li>
                <li>
                  <a href="https://www.riterz.com/pricing">Pricing</a>
                </li>
                <li>
                  <p-divider></p-divider>
                </li>
                <li>
                  <a href="https://www.riterz.com/about-us">About us</a>
                </li>
                <li>
                  <a href="https://www.riterz.com/partners">Partners</a>
                </li>
                <li>
                  <a href="https://riterz.bamboohr.com/careers">Careers</a>
                </li>
                <li>
                  <a href="https://www.riterz.com/contact-us">Contact us</a>
                </li>
              </ul>
            </nav>
          </p-popover>
        </li>
      </ul>
    </nav>

    <div class="rt-user-settings">
      @defer (on viewport(header)) {
        @if (!loadingUser()) {
          @if (currentUser()) {
            @if (currentUser()?.status !== 'pending' && currentUser()?.status !== 'rejected') {
              <p-button
                class="rt-submit-profile-button"
                label="Submit your Profile"
                [text]="true"
                [rounded]="true"
                severity="secondary"
                (click)="openProfileForm()"
              />
            }
            @if (currentUser()?.status !== 'pending' && currentUser()?.status !== 'rejected') {
              <p-button
                [style]="{ marginRight: '12px' }"
                [text]="true"
                [rounded]="true"
                [icon]="'pi pi-search'"
                severity="secondary"
                (click)="showSearch()"
              />
            }
            @if ((currentUser()?.organizations?.length || 0) > 0 || isSuperAdmin()) {
              <rt-organization-switcher
                [organizations]="currentUser()?.organizations || []"
                [canBrowseAll]="isSuperAdmin()"
              />
            }
            @if (currentUser()?.image_url) {
              <p-avatar
                class="rt-clickable"
                (click)="opProfileNav.toggle($event)"
                [image]="currentUser()?.image_url"
                size="large"
                shape="circle"
              />
            } @else {
              <p-avatar
                class="rt-clickable"
                [style]="{'background-color': '#200B39', 'color': '#FFF'}"
                (click)="opProfileNav.toggle($event)"
                [image]="currentUser()?.image_url"
                [label]="currentUser()?.first_name?.charAt(0)! + currentUser()?.last_name?.charAt(0)"
                size="large"
                shape="circle"
              />
            }
            <p-popover #opProfileNav appendTo="body">
              <nav class="rt-nav">
                <ul>
                  @if (isSuperAdmin()) {
                    <li>
                      <a [routerLink]="['/admin']" (click)="opProfileNav.hide()">
                        Admin
                      </a>
                    </li>
                  }
                  <li>
                    <a [routerLink]="['/account']" (click)="opProfileNav.hide()">
                      Account
                    </a>
                  </li>
                  <li>
                    <a [routerLink]="['/connect-claude']" (click)="opProfileNav.hide()">
                      Connect to Claude
                    </a>
                  </li>
                  <li>
                    <a
                      class="rt-clickable"
                      tabindex="0"
                      (click)="logout(); opProfileNav.hide()"
                      (keydown.space)="logout(); opProfileNav.hide()"
                    >
                      Logout
                    </a>
                  </li>
                </ul>
              </nav>
            </p-popover>
          }
        }
      }
    </div>
  </div>
</header>
}

<div class="rt-body">
  <div class="rt-loading on" [class.on]="loading()"><div class="rt-spinner"></div></div>
  <router-outlet></router-outlet>
</div>

<p-toast
  position="bottom-right"
  showTransitionOptions="200ms"
  showTransformOptions="translateY(100%)"
  hideTransitionOptions="200ms"
  hideTransformOptions="translateY(-100%)"
/>
<p-confirmDialog />
<rt-search />
